import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dtd } from './dtd';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DtdService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Dtd[]> {
    return this.httpClient.get<Dtd[]>(this.baseUrl + 'api/DtdApi')
  }
  Post(dtd: Dtd): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DtdApi/add', dtd, { headers: header, observe: 'response' })
  }
  Delete(dtd: Dtd) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DtdApi/activeordeactive', dtd, { headers: header, observe: 'response' })
  }
  Put(dtd: Dtd): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DtdApi/Update', dtd, { headers: header, observe: 'response' })
  }
  GetActive(): Observable<Dtd[]> {
    return this.httpClient.get<Dtd[]>(this.baseUrl + 'api/DtdApi/GetActive')
  }

}
